/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSessionFull,
  UnifiedClassSessionFullOptional,
  UnifiedClassSessionFullMetaI,
  UnifiedClassSessionFullTrackedI,
} from "./unified-class-session-full";
import {
  UnifiedClassSessionFullTracked,
  UnifiedClassSessionFullMeta,
} from "./unified-class-session-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithCancelledDatetime,
  WithCancelledDatetimeOptional,
  WithCancelledDatetimeMetaI,
  WithCancelledDatetimeTrackedI,
} from "./with-cancelled-datetime";
import {
  WithCancelledDatetimeTracked,
  WithCancelledDatetimeMeta,
} from "./with-cancelled-datetime";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithSessionLength,
  WithSessionLengthOptional,
  WithSessionLengthMetaI,
  WithSessionLengthTrackedI,
} from "./with-session-length";
import {
  WithSessionLengthTracked,
  WithSessionLengthMeta,
} from "./with-session-length";

/**
 *
 * @export
 * @interface ClassSessionDTO
 */
export interface ClassSessionDTOOptional extends UnifiedClassSessionFullOptional {
  /**
   *
   * @type {number}
   * @memberof ClassSessionDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof ClassSessionDTO
   */
  sessionDatetime?: Date;
  /**
   *
   * @type {number}
   * @memberof ClassSessionDTO
   */
  sessionLength?: number;
  /**
   *
   * @type {string}
   * @memberof ClassSessionDTO
   */
  cancelledDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassSessionDTO
   */
  endDatetime?: Date;
}

export interface ClassSessionDTO
  extends
    ClassSessionDTOOptional,
    UnifiedClassSessionFull,
    WithCancelledDatetime,
    WithSessionLength {
  /**
   *
   * @type {number}
   * @memberof ClassSessionDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof ClassSessionDTO
   */
  sessionDatetime?: Date;
  /**
   *
   * @type {number}
   * @memberof ClassSessionDTO
   */
  sessionLength?: number;
  /**
   *
   * @type {string}
   * @memberof ClassSessionDTO
   */
  cancelledDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassSessionDTO
   */
  endDatetime?: Date;
}

export interface ClassSessionDTOTrackedI extends UnifiedClassSessionFullOptional {
  /**
   *
   * @type {number}
   * @memberof ClassSessionDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSessionDTO
   */
  sessionDatetime?: Date;
  sessionDatetimeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassSessionDTO
   */
  sessionLength?: number;
  sessionLengthIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSessionDTO
   */
  cancelledDatetime?: Date;
  cancelledDatetimeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSessionDTO
   */
  endDatetime?: Date;
  endDatetimeIsSet: boolean;
}

transformDatesMap.set("ClassSessionDTO", function (model: ClassSessionDTO) {
  if (typeof model.sessionDatetime == "string")
    model.sessionDatetime = new Date(model.sessionDatetime);
  if (typeof model.cancelledDatetime == "string")
    model.cancelledDatetime = new Date(model.cancelledDatetime);
  if (typeof model.endDatetime == "string")
    model.endDatetime = new Date(model.endDatetime);
});

export type ClassSessionDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  sessionDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  sessionLength: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  cancelledDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endDatetime: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var ClassSessionDTOMeta: ClassSessionDTOMetaI =
  {} as ClassSessionDTOMetaI;
ClassSessionDTOMeta = typeMeta("ClassSessionDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  sessionDatetime: propertyMeta(
    "sessionDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  sessionLength: propertyMeta(
    "sessionLength",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  cancelledDatetime: propertyMeta(
    "cancelledDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endDatetime: propertyMeta(
    "endDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
});

const metaI = ClassSessionDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassSessionFullMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassSessionFullMeta.assignId;
  metaI.sessionDatetime.inheritedFrom =
    UnifiedClassSessionFullMeta.sessionDatetime;
  metaI.interfaces = metaI.interfaces.concat([WithSessionLengthMeta]);
  metaI.sessionLength.inheritedFrom = WithSessionLengthMeta.sessionLength;
  metaI.interfaces = metaI.interfaces.concat([WithCancelledDatetimeMeta]);
  metaI.cancelledDatetime.inheritedFrom =
    WithCancelledDatetimeMeta.cancelledDatetime;
});

export class ClassSessionDTOTracked
  extends UnifiedClassSessionFullTracked
  implements ClassSessionDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  sessionDatetime__I?: Date = undefined;
  sessionDatetimeIsSet: boolean = false;
  set sessionDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.sessionDatetime__I = v;
      this.sessionDatetimeIsSet = true;
    } else {
      this.sessionDatetime__I = v || undefined;
      this.sessionDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionDatetime() {
    return this.sessionDatetime__I;
  }
  sessionLength__I?: number = undefined;
  sessionLengthIsSet: boolean = false;
  set sessionLength(v: undefined | number) {
    if (v !== undefined) {
      this.sessionLength__I = v;
      this.sessionLengthIsSet = true;
    } else {
      this.sessionLength__I = v || undefined;
      this.sessionLengthIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionLength() {
    return this.sessionLength__I;
  }
  cancelledDatetime__I?: Date = undefined;
  cancelledDatetimeIsSet: boolean = false;
  set cancelledDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.cancelledDatetime__I = v;
      this.cancelledDatetimeIsSet = true;
    } else {
      this.cancelledDatetime__I = v || undefined;
      this.cancelledDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get cancelledDatetime() {
    return this.cancelledDatetime__I;
  }
  endDatetime__I?: Date = undefined;
  endDatetimeIsSet: boolean = false;
  set endDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.endDatetime__I = v;
      this.endDatetimeIsSet = true;
    } else {
      this.endDatetime__I = v || undefined;
      this.endDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get endDatetime() {
    return this.endDatetime__I;
  }
  constructor(config?: ClassSessionDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: ClassSessionDTOOptional,
    options?: AssignOptions,
  ): ClassSessionDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.sessionDatetime &&
      this.sessionDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.sessionDatetime = config.sessionDatetime;
      if (optionsRequired.unassign) this.sessionDatetimeIsSet = false;
      else this.sessionDatetimeIsSet = true;
    }
    if (
      config.sessionLength &&
      this.sessionLengthApplyFilter(optionsRequired.filter)
    ) {
      this.sessionLength = config.sessionLength;
      if (optionsRequired.unassign) this.sessionLengthIsSet = false;
      else this.sessionLengthIsSet = true;
    }
    if (
      config.cancelledDatetime &&
      this.cancelledDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.cancelledDatetime = config.cancelledDatetime;
      if (optionsRequired.unassign) this.cancelledDatetimeIsSet = false;
      else this.cancelledDatetimeIsSet = true;
    }
    if (
      config.endDatetime &&
      this.endDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.endDatetime = config.endDatetime;
      if (optionsRequired.unassign) this.endDatetimeIsSet = false;
      else this.endDatetimeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassSessionDTOTrackedI {
    const cloned = {} as ClassSessionDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.sessionDatetimeIsSetDeep() &&
      this.sessionDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionDatetimeIsSet = true;
      cloned.sessionDatetime = this.sessionDatetime;
    } else {
      //cloned.sessionDatetimeIsSet = false
    }
    if (
      this.sessionLengthIsSetDeep() &&
      this.sessionLengthApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionLengthIsSet = true;
      cloned.sessionLength = this.sessionLength;
    } else {
      //cloned.sessionLengthIsSet = false
    }
    if (
      this.cancelledDatetimeIsSetDeep() &&
      this.cancelledDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cancelledDatetimeIsSet = true;
      cloned.cancelledDatetime = this.cancelledDatetime;
    } else {
      //cloned.cancelledDatetimeIsSet = false
    }
    if (
      this.endDatetimeIsSetDeep() &&
      this.endDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endDatetimeIsSet = true;
      cloned.endDatetime = this.endDatetime;
    } else {
      //cloned.endDatetimeIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassSessionDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.sessionDatetimeApplyFilter(filter))
      this.sessionDatetimeIsSet = false;

    if (!this.sessionLengthApplyFilter(filter)) this.sessionLengthIsSet = false;

    if (!this.cancelledDatetimeApplyFilter(filter))
      this.cancelledDatetimeIsSet = false;

    if (!this.endDatetimeApplyFilter(filter)) this.endDatetimeIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionDTOMeta.assignId,
      ClassSessionDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  sessionDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionDTOMeta.sessionDatetime,
      ClassSessionDTOMeta,
      this.sessionDatetime,
      this,
    );
  }
  sessionDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionDatetimeIsSet && this.sessionDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  sessionLengthApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionDTOMeta.sessionLength,
      ClassSessionDTOMeta,
      this.sessionLength,
      this,
    );
  }
  sessionLengthIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionLengthIsSet && this.sessionLengthApplyFilter(filter))
      return true;

    return false;
  }
  cancelledDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionDTOMeta.cancelledDatetime,
      ClassSessionDTOMeta,
      this.cancelledDatetime,
      this,
    );
  }
  cancelledDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cancelledDatetimeIsSet &&
      this.cancelledDatetimeApplyFilter(filter)
    )
      return true;

    return false;
  }
  endDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionDTOMeta.endDatetime,
      ClassSessionDTOMeta,
      this.endDatetime,
      this,
    );
  }
  endDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endDatetimeIsSet && this.endDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.sessionDatetimeIsSetDeep(filter)) return true;
    if (this.sessionLengthIsSetDeep(filter)) return true;
    if (this.cancelledDatetimeIsSetDeep(filter)) return true;
    if (this.endDatetimeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
